import pa from "package.json";

export const Config = {
  VERSION: pa.version,
  APPLICATION_ADMIN_RID: 0,
  BACK_END_URL: "https://localhost:44372",
  BACK_END_URL2: "http://localhost:4455",
  DATE_LOCALE: "ar-JO",
  DATE_FORMATS: {
    DATE: "dd/MM/yyyy",
    DATE_TIME: "dd/MM/yyyy HH:mm",
    TIME: "hh:mm a",
    FULL_DATE: "EEEE, dd/MM/yyyy"
  },
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
  NUM_PATTERN: new RegExp("^[0-9]*$")
};
